/**
 * GA4 User-ID (GROWTH-8102).
 *
 * Without it GA4 counts devices, not members: every new browser or cleared cookie is a "new user". Once the dashboard
 * bootstrap names the signed-in member, `setGaUserId` gives gtag the member's internal Heritage Web user id, and every
 * later hit (gtag events and GTM's tags alike) carries it as `uid`. It is the id as a string, never an email or a
 * name, and it is the signed-in member's own id even while they work in a team owner's account. The server-side
 * Measurement Protocol events send the same value (`Hw_Listing_ApprovedEvent`, GROWTH-8101).
 *
 * `gtag("set", …)` rather than `gtag("config", …)`: a second `config` call was measured to attach no `uid` at all. See
 * docs/testing/inventories/gaUserId.md. Only the production build defines `window.gtag` (helpers/analyticsTags.js);
 * elsewhere both functions do nothing.
 */

const USER_ID_PATTERN = /^[1-9][0-9]*$/;

// The id gtag was last given in this page session, so a repeated bootstrap does not set it again.
let sentUserId = null;

export const gaUserIdFor = profile => {
  const userId = profile?.user_id == null ? "" : String(profile.user_id);

  return USER_ID_PATTERN.test(userId) ? userId : null;
};

export const setGaUserId = profile => {
  const userId = gaUserIdFor(profile);

  if (!userId || userId === sentUserId || typeof window.gtag !== "function") {
    return false;
  }

  window.gtag("set", { user_id: userId });
  sentUserId = userId;

  return true;
};

/** Called before every Keycloak sign-out (helpers/keycloakLogout.js), so a shared computer does not merge two members. */
export const clearGaUserId = () => {
  sentUserId = null;

  if (typeof window.gtag === "function") {
    window.gtag("set", { user_id: null });
  }
};
